<template>
  <div>
    <div class="row">
      <div class="col-12 mt-0">
        <b-card no-body  class="mb-0" style="width: 470px !important;">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <p class="button1">2. Información para la respuesta</p>
          </b-card-header>                            
          <b-card-body>                                
            <div class="row">
              <div class="col-12"> <!-- @change="findFilterBar($event)" -->
                <table class="table table-bordered table-striped table-hover table-sm">
                  <thead>
                    <tr>
                      <th><p class="p1">Colaborador</p></th>
                      <th><p class="p1">Cargo</p></th>
                      <th><p class="p1">Push</p></th>
                      <th><p class="p1">Activo</p></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in this.infoRPl.forum.participants" :key="index">
                      <td>
                        <p class="p1">{{row.name}}</p>
                      </td>
                      <td>
                        <p class="p1">{{row.position}}</p>
                      </td>
                      <td> <!--@click="deleteItem('tipoSelected',row.id)"-->
                        <button
                          v-show="row.status == 1"
                          type="button"
                          class="btn btn-light"
                          @click="sendPush(row.id)"
                        >
                          <img src="@/assets/images/icons/push.svg" />
                        </button>
                      </td>
                      <td> 
                        <b-form-radio-group
                          id="btn-radios-status"
                          v-model="statusUser[row.id]"
                          buttons
                        >
                          <b-form-radio
                            v-for="option in optionStatus"
                            :key="option.text"
                            :value="option.value"
                            :button-variant="option.variant"
                            @change="statusUserForum(row.id,$event)"
                          >                          
                            {{ option.text }}
                            </b-form-radio>
                        </b-form-radio-group> <!--  -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>                               
            <div class="col-12 text-right">
              <p class="p1">{{this.infoRPl.forum.participants.length}} Colaboradores en el foro</p>
            </div>                                
            <div v-show="addUserForm==0" class="col-12 mt-0 mb-0 text-right" style="text-decoration: underline;">
              <button v-show="canEdit != 1"
                type="button" class="btn btn-outline-light" 
                v-on:click="addUserForm = 1"
                :readonly="canEdit ? '' : disabled">
                <p class="p1"><b>+ Añadir participante</b></p>
              </button>
            </div>
            <div v-show="addUserForm==1">
              <form 
              @submit="addUserForum"
              onsubmit="return false"
              >
                <div class="row">
                  <div class="col-2 mt-0 mb-0 text-left">
                    <p class="p1"><b>Correo</b></p>
                  </div>
                  <div class="col-10 mt-0 mb-0 text-left">
                    <input type="email" 
                      v-model="email" class="form-control"
                      required
                      :readonly="canEdit ? '' : disabled">
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 mt-0 mb-0 pr-0 text-left">
                    <p class="p1"><b>Nombre</b></p>
                  </div>
                  <div class="col-4 mt-0 mb-0 ml-0 text-left">                    
                    <input type="text" 
                      v-model="nameUser" class="form-control"
                      required
                      :readonly="canEdit ? '' : disabled">
                  </div>
                  <div class="col-2 pl-0 mt-0 mb-0 text-right">
                    <p class="p1"><b>Cargo</b></p>
                  </div>
                  <div class="col-4 pl-0 mt-0 mb-0 text-left">
                    <input type="text" 
                      v-model="namePosition" class="form-control"
                      :readonly="canEdit ? '' : disabled"
                      >
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 mt-0 mb-0 text-left">
                    <p class="p1"><b>Mensaje</b></p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8 mt-0 mb-0 text-left">
                    <p class="p1">
                      <textarea v-model="msjForum" required cols="53"></textarea>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-0 mb-0 text-right"  style="text-decoration: underline;">
                    <button 
                      type="submit" 
                      class="btn btn-outline-light"
                      :readonly="canEdit ? '' : disabled">
                      <p class="p1"><b>+Invitar al foro</b></p>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-12 mt-0 mb-0 text-center" style="text-decoration: underline;"  v-show="canEdit != 1">
              <router-link :to='"/forum/"+this.$route.params.id+"/"+this.infoRPl.forum.id+"/"+ this.user.email'>
                <button type="button" 
                  class="btn btn-outline-secondary rounded-pill"
                  :readonly="canEdit ? '' : disabled">
                  Ver foro de información
                </button>
              </router-link>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <small v-show="error.flag" class="alert-danger">{{ error.message }}</small>
    </div>                    
    <div>
      <b-modal 
        ref="my-modal"
        scrollable
        class="col-6"
        hide-footer
        centered
        title="Atención al mensaje:"
        no-close-on-backdrop
        @hidden="hideModal">
        <div class="d-block text-center">
          <h3>{{this.msjModal}}</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger"
          block 
          @click="hideModal">
            Cerrar
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "RequestInfo",
  components: {
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,      
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      disabled: false,
      email: '',
      nameUser: '',
      namePosition: '',
      msjForum: '',
      forum: {
        participants: [],
      },
      msjModal: "",
      flagPath: false,
      addUserForm: 0,
      canEdit: '',

      statusUser: {},
      optionStatus: [
        { text: 'No', value: 0, variant: "outline-danger"},
        { text: 'Si', value: 1, variant: "outline-success"}
      ]
    };    
  },
  beforeMount() {
    this.canEdit = '';
    this.actGetInfoRP(this.$route.params.id).then(() =>{
      this.setInfoRPl(this.infoRP.data);
      if(this.infoRPl.status == 'closed'){
        this.canEdit = 1;
      }
      this.infoRPl.forum.participants.forEach(r => {
        this.statusUser[r.id] = r.status;        
      });
    });
    
  },
  computed: {
    ...mapState("modCore", ["user"]),    
    ...mapState("modRightPetition", [
      "infoRP",
      "infoRPl",
      "responsePush"
    ]),
  },
  methods:{
    ...mapActions("modRightPetition", [
      "actGetInfoRP",      
      "actAddUserForum",
      "actSendPush",
      "actSetStatusUserFrm"
    ]),

    ...mapMutations("modRightPetition", [
      "setStateProcess",
      "setInfoRPl",
      ]),

    addUserForum(){
      var data = [];
      data[0] = this.infoRPl.forum_id;
      data[1] = {
        'name': this.nameUser,
        'position': this.namePosition,
        'email': this.email,        
        'message': this.msjForum,
        'pdf': this.infoRPl.file,
      }

      this.actAddUserForum(data).then(() =>{
        this.actGetInfoRP(this.$route.params.id).then(() =>{
              this.setInfoRPl(this.infoRP.data);
              this.infoRPl.forum.participants.forEach(r => {
                this.statusUser[r.id] = r.status;
              });
            });
        this.addUserForm=0;
      });
    },

    sendPush(id){
      this.actSendPush(id).then(() =>{
        if(this.responsePush.message == true){
          this.showModal("El push se envio con exito",0);
        }
        else{
            this.showModal("Este usuario ya ha sido notificado el día de hoy, inténtalo nuevamente mañana",0);
        }
        
      });
    },   

    statusUserForum(idUser,e){      
      var data = [];      
      data[0] = idUser;
      data[1] = {
        'status': e
      }
      this.actSetStatusUserFrm(data).then(() =>{
        this.actGetInfoRP(this.$route.params.id).then(() =>{
          this.setInfoRPl(this.infoRP.data);
          this.statusUser = [];
          this.infoRPl.forum.participants.forEach(r => {
            this.statusUser[r.id] = r.status;        
          });
        });
      });
    },

    formatDateShow(date){
      var d = new Date(date);
      var datestring = d.getDate()+" "+this.monthNames[d.getMonth()+1] +" "+ d.getFullYear();
      return datestring;
    },
    
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },
  }
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-rightpetition {
  .title-1 {
        font-size: 24px;
        font-weight: bold;
        color: #1C3A4E;
      }
  .cont-rightpetition-text {    
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-rightpetition {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }     
           
    }
  }
  .button1 {
    //background: #E9ECEE;
    color: #1C3A4E;
    //border-radius: 50px;
    height: 25px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    
  }       
  .button2 {
    background: #1C3A4E;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button3 {
    border: none;
    background-color: inherit;
    padding: 5px 10px;
    font-size: 11px;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
  .button4 {
    background: #99A6AF;
    color: #ffffff;
    border-radius: 8px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99A6AF, 5);
    }
  }
  .button2:hover {background: #eee;}
  .default {color: black;}    
  .tr1{
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }   
  .td1 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;    
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }  
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #1C3A4E;
    border-color: #1C3A4E;  
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px
  }
  .p1 {
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;    
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .img1 {
    width: 18px;
    height: 18px;    
    left: 100%;
    top: 100%;     
    float: center;    
  }
  .centerImg1 {
    width: 16px;
    height: 16px;    
    top: 100%;    
    float: right;    
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #779B49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
      border: 1px solid #ccc;
      display: inline-block;
      padding: 1px 2px;
      cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }

  .file-upload-img{
    width:120px;
    height:80px;
    //border-style: dotted;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img{
      width:100%;
      height:100%;
  }
  input[type="file"]{
      opacity:0;
      filter:alpha(opacity=0);
      display:block;
      width:360px;
      height:200px;
      position:absolute;
      cursor:pointer;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
</style>